import { GNS } from './GNS.js';

/**
 * GNS.LoadEvent
 * 
 * Ajax通信などの非同期ロード結果を表すイベント
 * 
 * イベントタイプ:
 * - SUCCESS: 成功
 * - FAILED: 失敗
 * - CANCEL: キャンセル
 */
GNS.LoadEvent = function (a) {
    var b = a.create(a.Event);
    return b._static.SUCCESS = "success", b._static.FAILED = "failed", b._static.CANCEL = "cancel", b.init = function (
        a, c) {
        b._super.init.apply(this, [a, c])
    }, b.toString = function () {
        return "LoadEvent :: type -> " + this.type
    }, b._self
}(GNS);
